import axios from "axios";
import config, { environment } from "../config/enviroment";

const urlImagenesEpayco = environment.urlBaseEpayco;
const urlImagenesBucket = config.urlMultimedia;

export async function imageExists(url: string): Promise<boolean> {
  const encodedUrl = url.replace(" ", "%20");
  try {
    const response = await axios.get(encodedUrl);
    return response.status === 200;
  } catch (error) {
    return false;
  }
}

export function locateImage(imagePath: string): Promise<string> {
  return new Promise((resolve) => {
    const imageUrl1 = `${urlImagenesBucket}/${imagePath}`;
    const imageUrl2 = `${urlImagenesEpayco}/${imagePath}`;
    const img = new Image();

    img.onload = () => {
      resolve(imageUrl1);
    };

    img.onerror = () => {
      resolve(imageUrl2);
    };

    img.src = imageUrl1;
  });
}
